import PropTypes from 'prop-types';

export const constantFormType = PropTypes.shape({
  taxYear: PropTypes.string,
  constantId: PropTypes.string,
  jurisdictionId: PropTypes.string,
  description: PropTypes.string,
  value: PropTypes.string,
});
